import React from 'react'
import { ScreenReaderOnly } from '@moonpig/launchpad-components'
import { TextChatMessage } from '../../ChatMessages/types'
import { AgentMessageStyledBox, AgentMessageText } from './styled'
import { useLocaleText } from '../../locale'

export const AgentMessage = ({
  msg,
  id,
}: {
  msg: TextChatMessage
  id: number
}) => {
  const t = useLocaleText()
  const labelId = `chat-agent-message-label-${id}`
  const contentId = `chat-agent-message-content-${id}`

  return (
    <AgentMessageStyledBox
      aria-labelledby={`${labelId} ${contentId}`}
      data-testid="chat-agent-message"
      role="article"
    >
      <ScreenReaderOnly id={labelId}>
        {t('concierge_chat.screen_reader_assistant_label')}
      </ScreenReaderOnly>
      <AgentMessageText id={contentId}>{msg.content}</AgentMessageText>
    </AgentMessageStyledBox>
  )
}
